// @ts-nocheck
import { SOCKET_CONTEXT_CHANGED, SOCKET_CONTEXT_CLEARED, SOCKET_INSTANCE_CHANGED } from '../types';

const initialState = {
    socketInstance: null,
    context: {},
};

const socket = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case SOCKET_INSTANCE_CHANGED: {
            return {
                ...state,
                socketInstance: payload,
            };
        }
        case SOCKET_CONTEXT_CHANGED: {
            return {
                ...state,
                context: { ...state.context, ...payload },
            };
        }
        case SOCKET_CONTEXT_CLEARED: {
            return {
                ...state,
                context: {},
            };
        }
        default:
            return state;
    }
};

export default socket;
